import { createSelector } from '@ngrx/store';

import { memberCardBarcodesImagesState } from '../root';

export const getMemberCardBarcodeImage = (memberId: number, barcodeType: OLO.Enums.BARCODE_SYMBOLOGY = OLO.Enums.BARCODE_SYMBOLOGY.CODE_QR) =>
    createSelector(
        memberCardBarcodesImagesState,
        (memberCardBarcodesImages) => memberCardBarcodesImages.find((obj) => obj.memberId === memberId && obj.barcodeType === barcodeType) || null,
    );
